<div class="onboarding-container" *ngIf="isTrial && showOnboarding">
  <div class="formula-info">
    <ng-icon name="heroClock" class="icon" size="24px"></ng-icon>
    <div class="texts">
      <span>Version d'essai</span>
      <span class="formula">FORMULE {{ evaSubscription?.formula }}</span>
    </div>
  </div>
  <div class="content" *ngIf="!selectedObItem">
    <div class="ob-items">
      <div class="ob-item" *ngFor="let item of onboardingItems" (click)="showObItem(item.id)">
        <img
          *ngIf="!item.done"
          src="assets/img/uncheck-circle.svg"
          style="
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            stroke-width: 2px;
            stroke: var(--Tokens-border-border-secondary, #d0d8e8);
          "
        />
        <img
          *ngIf="item.done"
          src="assets/img/check-circle.svg"
          style="
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            stroke-width: 2px;
            stroke: var(--Tokens-border-border-secondary, #d0d8e8);
          "
        />
        <span [class.done]="item.done">{{ item.name }}</span>
      </div>
    </div>
    <div class="ob-more">
      <div class="ob-texts">
        <span
          style="
            color: var(--Tokens-text-text-primary-invert, #fff);
            font-family: var(--Tokens-fonts-familly-font-heading, Outfit);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          "
          >C’est parti !</span
        >
        <span
          style="
            color: var(--Tokens-text-text-primary-invert, #fff);
            font-family: var(--Tokens-fonts-familly-font-heading, Outfit);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            width: 150px;
          "
          >Prenons en main le logiciel, que souhaitez-vous faire ?</span
        >
      </div>
      <div class="ob-img">
        <img style="height: 110px" src="assets/img/onboarding-guy.png" />
      </div>
    </div>
  </div>
  <div class="content" *ngIf="selectedObItem">
    <div class="side-content" *ngIf="!selectedObStep.finish">
      <img style="height: 110px" src="assets/img/onboarding-guy.png" />
      <div class="side-texts">
        <span class="title">{{ selectedObItem.sideTitle }}</span>
        <span class="subtitle">{{ selectedObItem.sideSubtitle }}</span>
      </div>
    </div>
    <div class="splitter" *ngIf="!selectedObStep.finish">
      <img src="assets/img/blue-splitter.svg" />
      <div class="step">{{ selectedObStep.step }}</div>
      <img src="assets/img/blue-splitter.svg" />
      <img src="assets/img/blue-splitter.svg" />
      <img src="assets/img/blue-splitter.svg" />
    </div>
    <div class="step-texts" *ngIf="!selectedObStep.finish">
      <span class="title"
        ><span>Étape {{ selectedObStep.step }} : </span>{{ selectedObStep.title }}</span
      >
      <span class="subtitle">{{ selectedObStep.subtitle }}</span>
    </div>
    <div class="step-actions" *ngIf="!selectedObStep.finish">
      <eva-button
        variant="text"
        severity="secondary"
        *ngIf="!selectedObStep.finish"
        [label]="selectedObStep.backText"
        (click)="prevObStep()"
      ></eva-button>
      <eva-button severity="info" [label]="selectedObStep.nextText" (click)="nextObStep()"></eva-button>
    </div>

    <div class="step-finish" *ngIf="selectedObStep.finish">
      <img style="height: 110px" src="assets/img/onboarding-guy.png" />
      <div class="step-texts">
        <span class="title"
          ><span>Étape {{ selectedObStep.step }} : </span>{{ selectedObStep.title }}</span
        >
        <span class="subtitle">{{ selectedObStep.subtitle }}</span>
      </div>
      <eva-button severity="info" [label]="selectedObStep.nextText" (click)="nextObStep()"></eva-button>
    </div>
  </div>

  <!-- <div class="help">
    <div class="help-row1">
      <ng-icon name="heroInformationCircleMini" class="icon"></ng-icon>
      <span>Une question ?</span>
    </div>
    <span
      >Contactez-nous via la bulle de discussion<br />
      en bas de l’écran, nous vous répondrons<br />
      rapidement !</span
    >
  </div> -->
  <div class="actions">
    <eva-button
      label="Changer de formule"
      variant="soft"
      severity="secondary"
      [block]="true"
      (click)="openFormula(false)"
    ></eva-button>
    <eva-button label="Souscrire" [block]="true" (click)="openFormula(true)"></eva-button>
    <span
      (click)="showIntercom()"
      style="
        cursor: pointer;
        width: 100%;
        color: var(--Tokens-text-text-secondary, #0d2083);
        font-size: 13px;
        font-weight: var(--Tokens-fonts-weight-font-semibold, 600);
        text-align: center;
      "
    >
      Une question ?
    </span>
  </div>
</div>
